import React, { useEffect, useState } from 'react';
import chevron from '@/services/chevron';
import Loader from '@/pages/loader/Loader';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * AuthGuard is currently not being used effectively. It has temporarily been replaced
 * by the bootstrap process within app.tsx.
 *
 * TODO: Revaluate whether this auth guard needs to be raised higher in the component tree, or is no longer needed.
 * We were finding instances where components were fetching data before the auth guard had completed.
 *
 */
export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const mainAppUrl = import.meta.env.VITE_API_MAIN_APP;

      if (!mainAppUrl) {
        console.error('Missing VITE_API_MAIN_APP');
        setIsChecking(false);
        return;
      }

      try {
        const session = await chevron.validateSession();
        if (session) {
          setIsAuthenticated(true);
          setIsChecking(false);
        } else {
          const currentUrl = window.location.href;
          const returnUrl = encodeURIComponent(currentUrl);
          window.location.href = `${mainAppUrl}/login?nextUri=${returnUrl}`;
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        const currentUrl = window.location.href;
        const returnUrl = encodeURIComponent(currentUrl);
        window.location.href = `${mainAppUrl}/login?nextUri=${returnUrl}`;
      }
    };

    checkAuth();
  }, []);

  if (isChecking) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return <Loader />;
};
